const Styles = {
    'PopoverCloseButton': 'PopoverCloseButton_PopoverCloseButton--a0829db4'
};

export default Styles;